import { func, object, string } from 'prop-types'
import React from 'react'

import BoxContainer, {
  BACKGROUND_COLOR,
} from '../../../external/components/container/BoxContainer'
import Cont, { PAD_OVERRIDE_20 } from '../../../external/components/layout/Cont'
import Section from '../../../external/components/layout/Section'
import TextStyler, {
  DEFAULT_HEADER,
  FONT_SIZE,
  WHITE_TEXT,
} from '../../../external/components/text/TextStyler'
import { isEmpty } from '../../../external/utilities/GeneralUtils'
import { getTrackersConfig } from '../../../utilities/ConfigUtils'
import { hasCoordinates, isMapActive } from '../../../utilities/GeoMapUtils'
import { translate } from '../../Translation'
import FacilityList from '../../search/FacilityList'
import GeoMapStaticCmp from '../../shared/geoMap/GeoMapStaticCmp'
import Trackers, { ALL_CONTRACTS } from '../../sharedInternal/trackers/Trackers'
import FacilityDetails from './FacilityDetails'
import FacilityOverview from './FacilityOverview'

const OverviewLayout = ({
  intl,
  facility,
  params,
  contractConfig,
  forwardToSelectedProduct,
  onFacilitySelectRequest,
  getFacilityLinkObj,
  mainConfig,
  brandConfig,
  pageId,
}) => {
  let geoMap
  if (
    !facility.nonClientFacility &&
    hasCoordinates(facility.coordinates) &&
    !facility.hiddenOnMap
  ) {
    if (
      !isEmpty(mainConfig) &&
      !isEmpty(brandConfig) &&
      isMapActive(mainConfig, pageId)
    ) {
      const mapLabel = translate(intl, 'facility_map_lbl', {
        facilityName: facility.name,
      })
      geoMap = (
        <div className="facility-geo-map">
          <GeoMapStaticCmp
            mapFullURL={facility.staticMapURL}
            cmpLabel={mapLabel}
            cmpTitle={mapLabel}
          />
        </div>
      )
    }
  }

  let nearbyFacilitiesUI
  if (facility.nonClientFacility && !isEmpty(facility.nearbyFacilities)) {
    const nearbyTitleUI = (
      <TextStyler
        styleObj={{
          ...DEFAULT_HEADER,
          ...WHITE_TEXT,
          fontSize: FONT_SIZE.X3,
        }}
      >
        {translate(intl, 'labels_facility_nearby_facilites_note', {
          nearbyProximity: facility.nearbyProximity,
          facilityName: facility.name,
        })}
      </TextStyler>
    )
    nearbyFacilitiesUI = (
      <Cont>
        <Section />
        <BoxContainer
          header={nearbyTitleUI}
          titleBackgroundColor={BACKGROUND_COLOR.HIGHLIGHT_SUCCESS}
        >
          <Cont padOverride={PAD_OVERRIDE_20}>
            <FacilityList
              intl={intl}
              facilities={{ records: facility.nearbyFacilities }}
              onFacilitySelectRequest={onFacilitySelectRequest}
              getFacilityLinkObj={getFacilityLinkObj}
              hoveredMapMarker={{}}
              onFacilityCardHover={() => {}}
              onAddFacilityToFavorites={() => {}}
              onRemoveFacilityFromFavorites={() => {}}
              isAllowFavorites={false}
              favoritesModifiedInline={[]}
              isInlineLoading={false}
              inlineTxnData={{}}
              adConfig={{}}
              mainConfig={mainConfig}
            />
          </Cont>
        </BoxContainer>
        <Section />
      </Cont>
    )
  }

  let facilityDetailsUI
  if (!facility.nonClientFacility) {
    facilityDetailsUI = (
      <FacilityDetails
        contractConfig={contractConfig}
        intl={intl}
        facility={facility}
        params={params}
        onSelectProduct={forwardToSelectedProduct}
        mainConfig={mainConfig}
        pageId={pageId}
      />
    )
  }

  const getTrackers = function () {
    return (
      <Trackers
        pageId={pageId}
        trackersConfig={getTrackersConfig(mainConfig)}
        contractCodes={[facility.contrCode, ALL_CONTRACTS]}
      />
    )
  }

  return (
    <div>
      <FacilityOverview intl={intl} facility={facility} params={params} />
      {nearbyFacilitiesUI}
      {geoMap}
      {facilityDetailsUI}
      {/* {goToSiteListButton} */}
      {getTrackers()}
    </div>
  )
}

OverviewLayout.propTypes = {
  params: object.isRequired,
  theme: string.isRequired,
  intl: object.isRequired,
  facility: object.isRequired,
  contractConfig: object.isRequired,
  forwardToFacilitySiteList: func.isRequired,
  forwardToSelectedProduct: func.isRequired,
  onFacilitySelectRequest: func.isRequired,
  getFacilityLinkObj: func.isRequired,
  mainConfig: object.isRequired,
  brandConfig: object.isRequired,
  pageId: string.isRequired,
  onGoToLOBPageRequest: func.isRequired,
}

export default OverviewLayout
